var $c7ab180b401e49ff$exports = {};
$c7ab180b401e49ff$exports = {
  "ascending": "\u0432\u0438\u0441\u0445\u0456\u0434\u043D\u0438\u0439",
  "ascendingSort": function ascendingSort(args) {
    return "\u0432\u0456\u0434\u0441\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0441\u0442\u043E\u0432\u043F\u0446\u0435\u043C ".concat(args.columnName, " \u0443 \u0432\u0438\u0441\u0445\u0456\u0434\u043D\u043E\u043C\u0443 \u043F\u043E\u0440\u044F\u0434\u043A\u0443");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u043F\u0456\u043A\u0441.");
  },
  "descending": "\u043D\u0438\u0437\u0445\u0456\u0434\u043D\u0438\u0439",
  "descendingSort": function descendingSort(args) {
    return "\u0432\u0456\u0434\u0441\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0441\u0442\u043E\u0432\u043F\u0446\u0435\u043C ".concat(args.columnName, " \u0443 \u043D\u0438\u0437\u0445\u0456\u0434\u043D\u043E\u043C\u0443 \u043F\u043E\u0440\u044F\u0434\u043A\u0443");
  },
  "resizerDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0437\u043C\u0456\u043D\u0443 \u0440\u043E\u0437\u043C\u0456\u0440\u0443",
  "select": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438",
  "selectAll": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435",
  "sortable": "\u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C"
};
export { $c7ab180b401e49ff$exports as default };